export const getDevice = async (deviceId: string): Promise<IDevice> => {
  const response = await fetch(`/api/v1/device/${deviceId}`);

  if (!response.ok) {
    throw new Error(`Device ${deviceId} could not be found.`);
  }

  return response.json();
};

interface IDevice {
  id: string;
  os: string;
  kioskUrl: string;
  squareupSettings: {
    clientId: string;
    locationId: string;
    personalAccessToken: string;
  };
  agency: {
    id: string;
    name: string;
    branchId: number;
    branchName: string;
  };
}



// WEBPACK FOOTER //
// ./src/services/devices/index.ts